import { render, staticRenderFns } from "./courseware-refers.vue?vue&type=template&id=6a1baf9d&scoped=true&"
import script from "./courseware-refers.vue?vue&type=script&lang=js&"
export * from "./courseware-refers.vue?vue&type=script&lang=js&"
import style0 from "./courseware-refers.vue?vue&type=style&index=0&id=6a1baf9d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a1baf9d",
  null
  
)

export default component.exports